import { render } from "./UploadDoclist.vue?vue&type=template&id=5651097b&scoped=true"
import script from "./UploadDoclist.vue?vue&type=script&lang=js"
export * from "./UploadDoclist.vue?vue&type=script&lang=js"

import "./UploadDoclist.vue?vue&type=style&index=0&id=5651097b&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5651097b"]])

export default __exports__